import React, { useState, useContext, useEffect } from "react";
import {
  Container,
  Segment,
  Form,
  Icon,
  Button,
  Modal,
} from "semantic-ui-react";
import { RootStoreContext } from "../../app/stores/rootStore";
import { IUserFormValues } from "../../app/models/user";
import { Form as FinalForm, Field } from "react-final-form";
import TextInput from "../../app/common/form/TextInput";
import {
  combineValidators,
  isRequired,
  composeValidators,
  hasLengthGreaterThan,
  hasLengthLessThan,
} from "revalidate";
import SendEmailResetPassword from "./SendEmailResetPassword";
import PrivacyPolicyModal from "./PrivacyPolicyModal";
import { observer } from "mobx-react-lite";

const validate = combineValidators({
  username: composeValidators(
    isRequired({ message: "Usuario de acceso es obligatorio" }),
    hasLengthLessThan(129)({
      message: "El Usuario de acceso debe tener máximo 128 caracteres",
    })
  )(),
  password: composeValidators(
    isRequired({ message: "La contraseña es obligatoria" }),
    hasLengthGreaterThan(7)({
      message: "La contrseña debe tener al menos 8 caracteres",
    })
  )(),
});

const LoginForm = () => {
  //variables para el modal
  const [open, setOpen] = useState(false);
  const onClose = () => setOpen(false);
  const onOpen = () => setOpen(true);

  const [openPrivacy, setOpenPrivacy] = useState(false);

  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { login, relogFromLogin, isLoggedIn } = rootStore.userStore;
  const { loading, changeState } = rootStore.buttonLoadingStore;

  useEffect(() => {
    if (!isLoggedIn) {
      relogFromLogin();
    }
  }, [isLoggedIn, relogFromLogin]);

  //variables para mostrar la contraseña
  const [shown, setShown] = useState(false);
  const switchShown = () => setShown(!shown);

  const [objAuthenticate] = useState<IUserFormValues>({
    username: "",
    password: "",
  });

  const handleFinalFormSubmit = (values: IUserFormValues) => {
    values.password = values.password.trim();
    changeState();
    login(values);
  };

  document.title = "Majim-e Factura Electrónica - Login";
  return (
    <div className="centered">
      <Segment clearing padded="very" className="loginDiv">
        <FinalForm
          validate={validate}
          initialValues={objAuthenticate}
          onSubmit={handleFinalFormSubmit}
          render={({ handleSubmit }) => (
            <Form onSubmit={handleSubmit}>              
              <Container textAlign="center">                
                <img src="/majimeLogo.png" width="300px"/>
                <br/>
                <br/>
              </Container>
              <Field
                name="username"
                placeholder="Usuario de acceso"
                value={objAuthenticate.username}
                component={TextInput}
              />
              <Container textAlign="right">
                <a
                  href="#pc"
                  className="password__button"
                  onClick={switchShown}
                >
                  {shown ? "Ocultar contraseña" : "Mostrar contraseña"}
                </a>
              </Container>
              <Field
                name="password"
                id="password"
                placeholder="Contraseña"
                type={shown ? "text" : "password"}
                value={objAuthenticate.password}
                component={TextInput}
              />
              <a href="#oc" onClick={onOpen}>
                Olvidé mi contraseña
              </a>
              <Container textAlign="center">
                <br />
                <Button
                  loading={loading}
                  disabled={loading}
                  className="ui primary button"
                  color="blue"
                  type="submit"
                  content="INGRESAR"
                />

                <br />
                <br />
                <p>{new Date().getFullYear()} © Todos los derechos reservados. <a href="https://majim-e.co" target="_blank" rel="noreferrer">Majim-e</a></p>
                <a href="#pp" onClick={(e) => { e.preventDefault(); setOpenPrivacy(true); }}>
                  Política de Privacidad <Icon name="external alternate" />
                </a>
              </Container>
            </Form>
          )}
        />
      </Segment>
      <PrivacyPolicyModal open={openPrivacy} onClose={() => setOpenPrivacy(false)} />

      <Modal size="tiny" open={open} centered={false} onClose={onClose} style={{ borderRadius: 10, border: "1px solid #082933" }}>
        <Modal.Header style={{ position: "relative", borderRadius: "10px 10px 0 0" }}>
          Recuperar contraseña
          <a
            href="#"
            onClick={(e) => { e.preventDefault(); onClose(); }}
            style={{ position: "absolute", top: "50%", right: "1em", transform: "translateY(-50%)", lineHeight: 1 }}
          >
            <Icon name="close" size="small" style={{ color: "#999", margin: 0 }} />
          </a>
        </Modal.Header>
        <Modal.Content style={{ borderRadius: "0 0 10px 10px" }}>
          <SendEmailResetPassword />
        </Modal.Content>
      </Modal>
    </div>
  );
};

export default observer(LoginForm);
